import { combineReducers } from '@reduxjs/toolkit';

import atashsooziOmumiBimehNamehDetailSlice from '../Detail/reducers/AtashsooziOmumiBimehNamehDetailSlice';
import elhaghiyehHayeSaderehSlice from '../ElhaghiyehHayeSadereh/reducers/elhaghiyehHayeSaderehSlice';
import atashsooziEstelamAndSodoorReducer from '../EstelamAndSodoor/Action/reducer';

export const atashsooziReducers = combineReducers({
  estelamAndSodoor: atashsooziEstelamAndSodoorReducer,
  bimehNamehDetail: atashsooziOmumiBimehNamehDetailSlice,
  elhaghiyehHayeSadereh: elhaghiyehHayeSaderehSlice,
} as any);
